// "Monthly"
// "Weekly"
// "Semi-Monthly"
// "Bi-Weekly"
// "4-Weekly"

// "Net 30"
// "Net 45"
// "Pay on Pay"
// "Net 15"
// "Net 60"
// "Net 7"
export const billiCycles = [{ name: "Weekly" }, { name: "Bi-Weekly" }, { name: "4-Weekly" }, { name: "Semi-Monthly" }, { name: "Monthly" }, { name: "Custom" }];
export const paymentTerms = [{ name: "Net 30" }, { name: "Net 45" }, { name: "Pay on Pay" }, { name: "Net 15" }, { name: "Net 60" }, { name: "Net 7" }];

export const getDates = (recent: { pO_ID: number | null, toDate: Date | null }, po: { Billing_Cycle: string | null, Payment_Term: string | null, project_Start_Date: Date | null, project_End_Date: Date | null, timesheet_Week_Start_Day: number }) => {
    let respFromDate = new Date();
    let respToDate = new Date();
    let respDueDate = new Date();
    let respInvoiceDate = new Date();
    const weekStartDay = po?.timesheet_Week_Start_Day || 0;
    if (po && recent.pO_ID && po.Billing_Cycle === "Monthly") {
        if (recent.toDate === null) {
            var month = new Date(po.project_Start_Date || "");
            var lastDayOfMonth = new Date(month.getFullYear(), month.getMonth() + 1, 0);
            respFromDate = new Date(po.project_Start_Date || "");
            respToDate = new Date(lastDayOfMonth.toString());
            respInvoiceDate = new Date();
        } else if (recent.toDate !== null) {
            let getFromDateFullyear = new Date(recent.toDate || "").getMonth() + 1 === 12 ? new Date(recent.toDate || "").getFullYear() + 1 : new Date(recent.toDate || "").getFullYear();
            let getFromDateMonth = new Date(recent.toDate || "").getMonth() + 1 === 12 ? 0 : new Date(recent.toDate || "").getMonth() + 1;
            respFromDate = new Date(getFromDateFullyear, getFromDateMonth, 1);
            var lastDayOfMonth = new Date(respFromDate.getFullYear(), respFromDate.getMonth() + 1, 0);
            respToDate = new Date(lastDayOfMonth.toString());
            respInvoiceDate = new Date();
        }

        if (po.Payment_Term === "Net 30") {
            respDueDate = new Date(new Date().setDate(new Date(new Date()).getDate() + 30));
        }
        else if (po.Payment_Term === "Net 45") {
            respDueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 45));
        }
        else if (po.Payment_Term === "Pay on Pay") {
            //respDueDate = new Date(lastDayOfMonth.getFullYear(), lastDayOfMonth.getMonth(), lastDayOfMonth.getDay() + 45);
        }
        else if (po.Payment_Term === "Net 15") {
            respDueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 15));
        }
        else if (po.Payment_Term === "Net 60") {
            respDueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 60));
        }
        else if (po.Payment_Term === "Net 7") {
            respDueDate = new Date(new Date(new Date()).setDate(new Date(new Date()).getDate() + 7));
        };
    }
    if (po && recent.pO_ID && po.Billing_Cycle === "Weekly") {
        if (recent.toDate === null) {
            respFromDate = new Date(po.project_Start_Date || "");
            const currentDate = new Date(po.project_Start_Date || "");
            //let numberOfDaysToAdd = (7 - Number(new Date(po.project_Start_Date || "")?.getDay()));
            let numberOfDaysToAdd = (weekStartDay - Number(new Date(po.project_Start_Date || "")?.getDay()) + 7) % 7;
            const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
            respToDate = toDate;
            respInvoiceDate = new Date();
        } else if (recent.toDate !== null) {
            const fromDate = new Date(new Date(recent.toDate || "").setDate(new Date(recent.toDate || "").getDate() + 1));
            respFromDate = fromDate;
            let numberOfDaysToAdd = (weekStartDay - Number(fromDate?.getDay()) + 7) % 7;
            const newFromDate = new Date(new Date(recent?.toDate || "").setDate(new Date(recent?.toDate || "").getDate() + 1));
            // const toDate = new Date(new Date(recent.toDate || "").setDate(new Date(recent.toDate || "").getDate() + 7));
            const toDate = new Date(newFromDate.setDate(newFromDate.getDate() + numberOfDaysToAdd));
            respToDate = toDate;
            respInvoiceDate = new Date();
        }

        if (po.Payment_Term === "Net 30") {
            respDueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
        }
        else if (po.Payment_Term === "Net 45") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 45))
        }
        else if (po.Payment_Term === "Pay on Pay") {
            //respDueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
        }
        else if (po.Payment_Term === "Net 15") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 15))
        }
        else if (po.Payment_Term === "Net 60") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 60))
        }
        else if (po.Payment_Term === "Net 7") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 7))
        };
    }
    if (po && recent.pO_ID && po.Billing_Cycle === "Semi-Monthly") {
        if (recent.toDate === null) {
            respFromDate = new Date(po.project_Start_Date || "");
            let toDateYear = respFromDate.getFullYear();
            let toDateMonth = respFromDate.getMonth();
            let toDateDay = respFromDate.getDate() < 16 ? 15 : new Date(respFromDate.getFullYear(), respFromDate.getMonth() + 1, 0).getDate();
            respToDate = new Date(toDateYear, toDateMonth, toDateDay);
            respInvoiceDate = new Date();
        } else if (recent.toDate !== null) {
            const recentDate = new Date(recent.toDate || "");
            let fromDate, toDate;

            if (recentDate.getDate() <= 15) {
                // Move to 16th of same month
                fromDate = new Date(recentDate.getFullYear(), recentDate.getMonth(), 16);
                toDate = new Date(recentDate.getFullYear(), recentDate.getMonth() + 1, 0); // end of month
            } else {
                // Move to 1st of next month
                fromDate = new Date(recentDate.getFullYear(), recentDate.getMonth() + 1, 1);
                toDate = new Date(recentDate.getFullYear(), recentDate.getMonth() + 1, 15);
            }

            respFromDate = fromDate;
            respToDate = toDate;
            respInvoiceDate = new Date();
        }
        if (po.Payment_Term === "Net 30") {
            respDueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
        }
        else if (po.Payment_Term === "Net 45") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 45));
        }
        else if (po.Payment_Term === "Pay on Pay") {
            //respDueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
        }
        else if (po.Payment_Term === "Net 15") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 15));
        }
        else if (po.Payment_Term === "Net 60") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 60));
        }
        else if (po.Payment_Term === "Net 7") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 7));
        };
    }
    if (po && recent.pO_ID && po.Billing_Cycle === "Bi-Weekly") {
        if (recent.toDate === null) {

            respFromDate = new Date(po.project_Start_Date || "");
            const currentDate = new Date(po.project_Start_Date || "");
            // let numberOfDaysToAdd = (7 - Number(new Date(po.project_Start_Date || "")?.getDay()));
            let numberOfDaysToAdd = (weekStartDay - Number(new Date(po.project_Start_Date || "")?.getDay()) + 7) % 7;
            const toDate = new Date(currentDate.setDate(currentDate.getDate() + (numberOfDaysToAdd + 7)));
            respToDate = toDate;
            respInvoiceDate = new Date();
        } else if (recent.toDate !== null) {
            const fromDate = new Date(new Date(recent.toDate || "").setDate(new Date(recent.toDate || "").getDate() + 1));
            respFromDate = fromDate;
            const currentDate = new Date(new Date(recent.toDate || "").setDate(new Date(recent.toDate || "").getDate() + 1));
            let numberOfDaysToAdd = (weekStartDay - Number(fromDate?.getDay()) + 7) % 7;
            // const newFromDate = new Date(new Date(recent?.toDate || "").setDate(new Date(recent?.toDate || "").getDate() + 1));
            const toDate = new Date(currentDate.setDate(currentDate.getDate() + (numberOfDaysToAdd) + (7)));
            respToDate = toDate;
            respInvoiceDate = new Date();
        }
        if (po.Payment_Term === "Net 30") {
            respDueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
        }
        else if (po.Payment_Term === "Net 45") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 45));
        }
        else if (po.Payment_Term === "Pay on Pay") {
            //respDueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
        }
        else if (po.Payment_Term === "Net 15") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 15));
        }
        else if (po.Payment_Term === "Net 60") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 60));
        }
        else if (po.Payment_Term === "Net 7") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 7));
        };
    }
    if (po && recent.pO_ID && po.Billing_Cycle === "4-Weekly") {
        if (recent.toDate === null) {
            respFromDate = new Date(po.project_Start_Date || "");
            const currentDate = new Date(po.project_Start_Date || "");
            // let numberOfDaysToAdd = (7 - Number(new Date(po.project_Start_Date || "")?.getDay()));
            let numberOfDaysToAdd = (weekStartDay - Number(new Date(po.project_Start_Date || "")?.getDay()) + 7) % 7;
            const toDate = new Date(currentDate.setDate(currentDate.getDate() + (numberOfDaysToAdd + 21)));
            respToDate = toDate;
            respInvoiceDate = new Date();
        } else if (recent.toDate !== null) {
            const fromDate = new Date(recent.toDate);
            fromDate.setDate(fromDate.getDate() + 1);
            respFromDate = new Date(fromDate);

            const toDate = new Date(fromDate);
            let numberOfDaysToAdd = (weekStartDay - Number(fromDate?.getDay()) + 7) % 7;
            toDate.setDate(toDate.getDate() + numberOfDaysToAdd + 21); // 28-day total
            respToDate = toDate;

            respInvoiceDate = new Date();
        }
        if (po.Payment_Term === "Net 30") {
            respDueDate = new Date(new Date().getMonth() + 1 === 12 ? new Date().getFullYear() + 1 : new Date().getFullYear(), 1, 0);
        }
        else if (po.Payment_Term === "Net 45") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 45));
        }
        else if (po.Payment_Term === "Pay on Pay") {
            //respDueDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDay() + 45);
        }
        else if (po.Payment_Term === "Net 15") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 15));
        }
        else if (po.Payment_Term === "Net 60") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 60));
        }
        else if (po.Payment_Term === "Net 7") {
            respDueDate = new Date(new Date().setDate(new Date().getDate() + 7));
        };
    }

    return {
        FromDate: respFromDate,
        ToDate: respToDate,
        DueDate: respDueDate,
        InvoiceDate: respInvoiceDate,
    };
};